import { useDispatch } from 'react-redux';
import { Button, Icon, Modal } from 'semantic-ui-react';
import { deleteOrganizationUser, deleteUser } from '../../../../store/actions';
import { trimText } from '../../../../utils/';
import { useTranslation } from 'react-i18next';

const WithdrawUserConfirmationModal = ({
  user,
  userActivities,
  modal,
  handleModal,
  isAdmin = null,
  ...props
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleDeleteOrgUser = () => {
    const { resetPage } = props;
    const isWithdrawnActivities = true;

    if (isAdmin) {
      dispatch(deleteUser(user.id, isWithdrawnActivities));
    } else {
      dispatch(deleteOrganizationUser(user.id, isWithdrawnActivities));
    }
    if (resetPage) resetPage();
  };

  const invitedDevelopmentActivities = userActivities.inDevelopmentInvited
    ? userActivities.inDevelopmentInvited
    : 0;

  const invitedActiveActivities = userActivities.inActiveInvited
    ? userActivities.inActiveInvited
    : 0;

  return (
    <>
      <Modal
        open={modal}
        closeIcon={
          <Icon
            onClick={() => handleModal(false)}
            name="close"
            className="closeicon"
          />
        }
        size="tiny"
      >
        <Modal.Header>
          {t('organisation.user_management.remove_user_invited_activities', {
            user_name: user && trimText(user.name, 15),
          })}
        </Modal.Header>
        <Modal.Content>
          <>
            {invitedDevelopmentActivities > 0 &&
              invitedActiveActivities === 0 && (
                <p>
                  {t(
                    'organisation.user_management.this_user_is_invited_to_in_development_activity',
                    { count: invitedDevelopmentActivities }
                  )}
                  <br />
                  {t(
                    'organisation.user_management.on_confirming_removal_the_user_will_be_withdrawn_from_all_invited_activities'
                  )}
                </p>
              )}
            {invitedDevelopmentActivities === 0 &&
              invitedActiveActivities > 0 && (
                <p>
                  {t(
                    'organisation.user_management.this_user_is_invited_to_in_active_activity',
                    { count: invitedActiveActivities }
                  )}
                  <br />
                  {t(
                    'organisation.user_management.on_confirming_removal_the_user_will_be_withdrawn_from_all_invited_activities'
                  )}
                </p>
              )}
            {invitedDevelopmentActivities > 0 &&
              invitedActiveActivities > 0 && (
                <p>
                  {t(
                    'organisation.user_management.this_user_is_invited_to_in_active_and_in_development_activity',
                    {
                      count: invitedActiveActivities,
                      count2: invitedDevelopmentActivities,
                    }
                  )}
                  <br />
                  {t(
                    'organisation.user_management.on_confirming_removal_the_user_will_be_withdrawn_from_all_invited_activities'
                  )}
                </p>
              )}
          </>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={() => {
              handleModal(false);
            }}
            className="modal-cancel"
          >
            {t('actions.cancel')}
          </Button>
          <Button
            onClick={() => {
              handleModal(false);
              handleDeleteOrgUser(true);
            }}
            className="modal-proceed"
            content={t('actions.confirm')}
          />
        </Modal.Actions>
      </Modal>
    </>
  );
};

export { WithdrawUserConfirmationModal };
